import { EmptyTableState } from '@/modules/common/components/EmptyTableState';
import { getDefaultMRTOptions } from '@/modules/common/lib/react-material-table';

import { ILearningBudgetTransactionInTheList } from '@/types/learning-budget';
import {
  MRT_TableOptions,
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { LEARNING_BUDGET_TRANSACTIONS_TABLE_COLUMNS } from './LearningBudgetTransactionsTable.columns';

type ListLearningBudgetTransactionsTableProps = {
  tableOptions: Omit<
    MRT_TableOptions<ILearningBudgetTransactionInTheList>,
    'columns'
  >;
};

const defaultMRTOptions =
  getDefaultMRTOptions<ILearningBudgetTransactionInTheList>();

export function ListLearningBudgetTransactionsTable({
  tableOptions,
}: ListLearningBudgetTransactionsTableProps) {
  const table = useMaterialReactTable<ILearningBudgetTransactionInTheList>({
    ...defaultMRTOptions,
    columns: LEARNING_BUDGET_TRANSACTIONS_TABLE_COLUMNS,
    renderEmptyRowsFallback: ({ table }) => {
      const { columnFilters, globalFilter } = table.getState();
      const hasFilters =
        globalFilter ||
        columnFilters.some(columnFilter =>
          Array.isArray(columnFilter.value)
            ? columnFilter.value.length
            : columnFilter.value,
        );

      return (
        <EmptyTableState
          hasFilters={hasFilters}
          emptyStateImage="/images/no-entries.png"
          emptyStateTitle="No transactions found"
          emptyStateMessage="Once a transaction happens, it will be displayed here."
        />
      );
    },
    enablePagination: !!tableOptions?.rowCount,
    ...tableOptions,
  });

  return <MaterialReactTable table={table} />;
}
